import {
  Backdrop,
  Box,
  Modal,
  Fade,
  IconButton,
  Typography,
} from "@mui/material";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Estrelas from "../../../../assets/images/coelho/estrelinhas.png";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "1px solid lightgray",
  borderRadius: 2,
  boxShadow: 24,
  p: 1,
  backgroundImage: `url(${Estrelas}), linear-gradient(#FFFFFF, #E6DFFF)`,
};

interface Props {
  openModal: boolean;
  setOpenModal(val: boolean): void;
  children: React.ReactNode | React.ReactNode[];
  width?: string | number;
  title?: string;
  turnBack?: VoidFunction | undefined;
  disableBackdropClick?: boolean;
}

export function CustomModal({
  openModal,
  setOpenModal,
  children,
  width,
  title,
  turnBack,
  disableBackdropClick = false,
}: Props) {
  const handleClose = (_event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      if (disableBackdropClick) {
        return;
      } else {
        setOpenModal(false);
      }
    }
  };

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      sx={{
        overflowY: "scroll",
      }}
    >
      <Fade in={openModal}>
        <Box
          sx={{
            ...style,
            width,
            maxHeight: "95%",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <Box
            width={"100%"}
            display={"flex"}
            justifyContent={title || turnBack ? "space-between" : "flex-end"}
            alignItems={"center"}
          >
            {turnBack && (
              <IconButton
                aria-label="delete"
                onClick={turnBack}
                sx={{ borderRadius: 2, pr: 2, height: 30 }}
              >
                <ArrowBackIosNewIcon style={{ fontSize: 30 }} />
                Back
              </IconButton>
            )}
            {title && (
              <Typography variant="h1" margin={"auto"}>
                {title}
              </Typography>
            )}
            <IconButton aria-label="delete" onClick={() => setOpenModal(false)}>
              <HighlightOffOutlinedIcon style={{ fill: "red", fontSize: 30 }} />
            </IconButton>
          </Box>
          {children}
        </Box>
      </Fade>
    </Modal>
  );
}
